import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import {
    Grid,
    Row,
    Col
} from 'react-bootstrap';
// Style
import r from 'quill/dist/quill.snow.css';
import s from './BlogContent.css';
import t from '../../styles/customQuillEditor.css'


class BlogContent extends Component {
    render() {
        const { initialValues } = this.props;
        let addClass = 'ql-editor frontend';

        return (
            <Grid fluid className={s.root}>
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12} className={cx(s.spaceTop3, s.space6)}>
                        <div className={s.previewPageWrapper}>
                            <div className={addClass} dangerouslySetInnerHTML={{ __html: initialValues.content }} >
                            </div>
                        </div>
                    </Col>
                </Row>
            </Grid>
        );
    }
}

export default withStyles(r, s, t)(BlogContent);
